<div class="users-container-top u-flex u-flex-justify-content-between u-flex-align-items-center">
  <div class="bold u-flex u-flex-align-items-center">
    <i class="icon-close" (click)="closeToolTipUsers()"></i>
    {{"HEADER.TOOLTIP_PARTICIPANTS.PARTICIPANTS" | translate}}
  </div>
  @if(config.features?.invite_participants){
    <div class="contract-btn u-flex" >
      <div (click)="showInviteForm = !showInviteForm">
        {{"HEADER.TOOLTIP_PARTICIPANTS.ADD" | translate}}
        <i class="icon-user"></i>
      </div>
      <!-- TOOLTIP AÑADIR PARTICIPANTES -->
       @if(showInviteForm){
         <sas-invite-participants (closeFormTooltip)="closeToolTipForm($event)">
         </sas-invite-participants>
       }
    </div>
  }
</div>

<div class="users-list">
  @for(participant of participantsData; track $index){
    <div class="user" >
      <div class="user-circle" [ngStyle]="{'background-color': participant.color}">
        {{ participant.initials }}
      </div>
      <div class="user-text">{{ participant.name }}</div>
    </div>
  }
</div>